import React from "react";
import {
  Radio,
  Typography,
} from "@material-ui/core";
import CustomDisabledCheckedIcon from "./customDisabledCheckedIcon";

const RadioQuestion = (props) => {

  const {
    options,
    isCompleted,
    onChange,
    value,
  } = props;

  return (
    <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
      {
        options.map((option) => {
          return (
            <div
              key={option}
              onClick={() => {
                if (isCompleted) return;
                onChange(option)
              }}
              style={{ cursor: isCompleted ? "default" : "pointer", display: "flex", alignItems: "center", marginRight: 20, flex: 1 }}
            >
              <Radio
                color="primary"
                checked={option === value}
                {...(isCompleted ? { checkedIcon: <CustomDisabledCheckedIcon /> } : undefined)}
                disabled={isCompleted}
              />
              <Typography className="whiteText">
                {option}
              </Typography>
            </div>
          )
        })
      }
    </div>
  );
}

export default RadioQuestion;